// Import source styles
import "../scss/app.scss";

// Load External Libraries
import './bootstrap';
//import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { setupOptimizedScrollThrottle } from "./modules/_throttle.mjs";
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { Accordion } from "./modules/_accordion.mjs";
import { heroSlider, meerActiviteitenSlider } from "./modules/_carousels.mjs";
import { headerscroll } from "./modules/_header.mjs";
import { leaflet } from "./modules/_leaflet.mjs";

document.addEventListener("DOMContentLoaded", function () {
    //AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    heroSlider();
    meerActiviteitenSlider();
    headerscroll();
    setupOptimizedScrollThrottle();

    const disclosure = new Disclosure();
    const accordion = new Accordion();

    let toolbar = document.querySelector('.toolbar');
    if (toolbar) {
        let search = document.getElementById('search-toggle');
        search.addEventListener('click', function() {
            if (toolbar.classList.contains('search-expanded')) {
                toolbar.classList.remove('search-expanded');
            } else {
                toolbar.classList.add('search-expanded');
            }
        });
    }

    document.querySelectorAll('.uitklap-toggle').forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('active');

            const content = button.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

});
leaflet();

import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#activiteiten-app')
